import React from 'react';
import Modal from 'react-modal';
import _ from 'lodash';
import Loader from './Loader';
import Sorting from './Sorting';
import '../css/SystemIntegratorAdd.css';
import SnackBar from './SnackBar';
import { Checkbox } from "@mui/material";


//assign okas box modal page
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        // minHeight: '10%',
        // maxHeight: '70%',
        height: '620px',
        overflow: 'auto',
        marginLeft: '260px',
        padding: '40px 90px 40px 90px',
        marginTop: '3%',
        background: '#EFF3F6',
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "none"
    },
};


const customStylesSuccess = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        minHeight: '50%',
        maxHeight: '70%',
        overflow: 'auto',
        padding: '2%',
        marginLeft: '260px',
        marginTop: '3%',
        background: '#EFF3F6',
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "none"
    },
};

export default class SupportAssignTicket extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: this.props.activeModal,
            modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
            modalStateAftereOpenSuccess: 'animated animated-duration-custom slideInDown',
            modalIsOpenSuccess: false,
            userData: [],
            selectedSI: [],
            loader: true,
            snackbarActive: false,
            snackbarMessage: '',
            sortingStatus: {
                sortingName: '',
                defaultDown: true
            },
        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.closeModalSuccess = this.closeModalSuccess.bind(this);

    }

    openModal() {
        this.setState({ modalIsOpen: true });
    }


    // closeModalSuccess() {
    //     this.setState({
    //         modalStateAftereOpenSuccess: 'animated animated-duration-custom slideOutUp'
    //     }, () => {
    //         setTimeout(() => {
    //             this.setState({
    //                 modalIsOpen: false,
    //                 modalIsOpenSuccess: false,
    //                 userData: [],
    //                 selectedSI: [],
    //             }, () => this.props.successMessage('success'))
    //         }, 500);

    //     })
    // }
    // closeModalSuccess() {
    //     this.setState({
    //         modalStateAftereOpenSuccess: 'animated animated-duration-custom slideOutUp',
    //         modalIsOpen: false
    //     }, () => {
    //         setTimeout(() => {
    //             this.setState({
    //                 modalIsOpenSuccess: false,
    //                 userData: [],
    //                 selectedSI: '',
    //             }, () => this.props.closeAllModal())
    //         }, 500);
    //     })
    // }

closeModalSuccess() {
    this.setState({
        modalStateAftereOpenSuccess: 'animated animated-duration-custom slideOutUp',
        modalIsOpen: false,
        loader: false
    }, () => {
        setTimeout(() => {
            this.setState({
                modalIsOpenSuccess: false,
                userData: [],
                selectedSI: '',
            }, () => {
                // ✅ Ask parent to clear selectedTicketIds
                if (typeof this.props.clearSelectedTicketIds === 'function') {
                    this.props.clearSelectedTicketIds();
                }

                if (typeof this.props.closeAllModal === 'function') {
                    this.props.closeAllModal();
                }
            });
        }, 500);
    });
}


    afterOpenModal() {
        // references are now sync'd and can be accessed.
        // this.subtitle.style.color = '#f00';
    }

    closeModal() {
        this.setState({
            modalStateAftereOpen: 'animated animated-duration-custom slideOutUp',

        }, () => {
            setTimeout(() => {
                this.setState({
                    modalIsOpen: false
                }, () => this.props.closeAllModal())
            }, 500);
        })
    }

    componentDidMount() {
        this.fetchUsers()
    }

    fetchUsers = () => {
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Authorization': tokenStored
        }
        fetch('/cloud/addUsers/', {
            method: "GET",
            headers: headers,
        })
            .then(response => {
                if (response.status === 403) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({ forceRefresh: true })
                    window.location.href = '/session-timeout'
                } else {
                    return response.json()
                }
            })
            .then(data => {
                this.setState({
                    userData: data,
                    actualData: data,
                    loader: false
                })
                // console.log(this.state.userData)
            })
            .catch((err) => {
                console.log(err)

            })
    }


    assignTicketCheckHandler = (selectedSI) => {
        this.setState({ selectedSI })
    }


    restoreData = (data) => {
        this.setState({
            userData: data
        })
    }


    sortingFunc = (type, searchValue) => {
        if (type !== 'search') {
            if (this.state.sortingStatus.sortingName === type) {
                this.setState({
                    sortingStatus: {
                        sortingName: type,
                        defaultDown: !this.state.sortingStatus.defaultDown
                    },
                }, () => {
                    if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
                        Sorting(this.restoreData, type, this.state.actualData);
                    } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
                        Sorting(this.restoreData, 'reverse', this.state.userData);
                    }
                })
            } else {
                this.setState({
                    sortingStatus: {
                        sortingName: type,
                        defaultDown: true
                    },
                }, () => {
                    if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
                        Sorting(this.restoreData, type, this.state.actualData);
                    } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
                        Sorting(this.restoreData, 'reverse', this.state.userData);
                    }
                })
            }
        } else if (type === 'search') {
            type = 'search';
            Sorting(this.restoreData, type, this.state.actualData, searchValue);
        } else {
            type = 'reverse';
            Sorting(this.restoreData, type, this.state.actualData);
        }
    }


    fetchIconType = (e) => {
        if (e === this.state.sortingStatus.sortingName && this.state.sortingStatus.defaultDown) {
            return 'fas fa-chevron-down pointer ml-2 float-right'
        } else if (e === this.state.sortingStatus.sortingName && !this.state.sortingStatus.defaultDown) {
            return 'fas fa-chevron-up pointer ml-2 float-right'
        } else {
            return 'fas fa-chevron-down pointer ml-2 float-right icon-inactive'
        }
    }

    renderAllUser = () => {
        if (this.state.userData !== null) {
            let someData = this.state.userData.map((userElement, index) => {
                return (
                    <tr key={index} className="some-hover below-click"  >
                        <th scope="col" style={{ width: '10%' }}>
                            <Checkbox
                                onChange={() => this.assignTicketCheckHandler(userElement.user_email)}
                                checked={this.state.selectedSI?.includes(userElement.user_email)}
                            />
                        </th>

                        <td scope='col' style={{ width: '20%', verticalAlign: 'middle' }}>{userElement.name}</td>
                        <td scope="col" style={{ width: '20%', verticalAlign: 'middle' }}>{userElement.role_created_by}</td>

                    </tr>
                )
            })
            return someData;
        } else {
            return null
        }
    }

    assignTicket = () => {

        const { selectedTicketIds } = this.props;  // get from props
        const { selectedSI } = this.state;         // selected user(s)
        // console.log("........f",this.props);

        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;

        var headers = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Authorization': tokenStored
        };
        // ✅ Start loader
        this.setState({ loader: true });

        fetch('/cloud/assignTicket/', {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                ticket_id: selectedTicketIds,     // <-- you already have it in props
                assigned_to: selectedSI           // <-- should be a string or array of emails
            })
        })
            .then(response => {
                if (response.status === 403) {
                    localStorage.clear();
                    window.location.href = '/session-timeout';
                } else {
                    return response.json();
                }
            })
            .then(data => {
                // console.log(data);
                if (data === 'Success') {
                    this.setState({
                        loader: false, // ✅ stop loader here
                        modalIsOpenSuccess: true,
                        modalIsOpen: false,

                    });
                } else {
                    this.setState({
                        snackbarActive: true,
                        snackbarMessage: "Something went wrong",
                        loader: false
                    });
                }
            })
            .catch(err => console.error(err));
    };



    render() {
        const { selectedTicketIds } = this.props;
        return (
            <React.Fragment>
                <SnackBar open={this.state.snackbarActive} handleSnackbarClose={() => {
                    this.setState({
                        snackbarActive: false
                    })
                }} message={this.state.snackbarMessage} />
                {this.state.loader ? <Loader /> : null}
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    className={this.state.modalStateAftereOpen}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <div className="modal-add-device">
                        <div className="float-right cross-times" onClick={this.closeModal}>
                            <i class="fas   fa-2x mr-2"></i>
                        </div>
                    </div>
                    <h3 className="modal-heading text-uppercase mb-2">ASSIGN TICKET</h3>
                    <div>
                        <table className="table" style={{ marginTop: '20px', width: '100%' }}>
                            <thead className="tableHeaderColor" style={{ borderRadius: '10px 10px 0px 0px' }}>
                                <th scope="col" style={{ width: '10%' }}></th>
                                <th scope="col" style={{ width: '20%' }}>User Name</th>
                                <th scope="col" style={{ width: '20%' }}>Email</th>

                            </thead>
                            <tbody style={{ height: '360px', overflowY: 'auto' }} >
                                {this.renderAllUser()}
                            </tbody>
                        </table>
                    </div>
                    <div className="float-right" style={{ marginTop: '20px', marginRight: '-15px' }}>
                        <div className="btn btn-new-grey" style={{ marginRight: '15px' }} onClick={this.closeModal}>Cancel</div>
                        <i className="fa fa-star-christmas fa-spin"></i>
                        <div className="btn btn-new-green " onClick={this.assignTicket} >Add</div>
                    </div>
                </Modal>
                <Modal
                    isOpen={this.state.modalIsOpenSuccess}
                    style={customStylesSuccess}
                    className={this.state.modalStateAftereOpenSuccess}
                    contentLabel="Example Modal">
                    <div className="modal-add-device">
                        <div className="float-right cross-times" onClick={this.closeModalSuccess}>
                            <i className="fas   fa-2x mr-2"></i>
                        </div>
                    </div>
                    {/* <div className="display-4 text-center">
                        <h3 className="modal-heading thanks-message">Ticket Assign Successfully
                        </h3>
                        <i class="fas fa-check-circle update"></i>
                        <br />
                        <div className="btn btn-new-grey"
                            onClick={(e) => {
                                this.setState({
                                    modalIsOpen: false,
                                    modalIsOpenSuccess: false,
                                    userData: [],
                                    selectedSI: '',
                                }, () => this.props.successMessage('success'))
                            }
                            }>
                            Close
                        </div>
                    </div> */}
                    <div className="display-4 text-center">
                        <h3 className="modal-heading thanks-message">Ticket Assign Successfully</h3>
                        <i class="fas fa-check-circle update"></i>
                        <br />
                        <div className="btn btn-new-grey"
                            onClick={this.closeModalSuccess}>
                            Close
                        </div>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}

